const rawBaseUrl = process.env.REACT_APP_API_URL || "";

const isLocalhostUrl = (url) =>
  /^https?:\/\/(localhost|127\.0\.0\.1)(:\d+)?/.test(url);

const isLocalNetworkBrowser = () => {
  if (typeof window === "undefined") return false;
  const host = window.location.hostname;
  return (
    host === "localhost" ||
    host === "127.0.0.1" ||
    host.startsWith("192.168.") ||
    host.startsWith("10.") ||
    /^172\.(1[6-9]|2\d|3[01])\./.test(host)
  );
};

const getApiBaseUrl = () => {
  const configuredUrl = rawBaseUrl.replace(/\/$/, "");

  // Rewrite localhost-based URLs (including "/api") to use the actual
  // hostname so that phones/tablets on the same local network can reach
  // the backend instead of hitting their own loopback address.
  const needsRewrite =
    typeof window !== "undefined" &&
    isLocalNetworkBrowser() &&
    (configuredUrl === "/api" || isLocalhostUrl(configuredUrl));

  if (needsRewrite) {
    if (configuredUrl === "/api") {
      // Proxy config: backend runs on port 5000 during dev
      return `${window.location.protocol}//${window.location.hostname}:5000/api`;
    }
    // Replace the localhost/127.0.0.1 hostname with the current one so
    // the port and path from REACT_APP_API_URL are preserved.
    return configuredUrl.replace(
      /^(https?:\/\/)(localhost|127\.0\.0\.1)/,
      `$1${window.location.hostname}`
    );
  }

  return configuredUrl;
};

export const API_BASE_URL = getApiBaseUrl();
const ASSET_BASE_URL = API_BASE_URL.replace(/\/api$/, "");

export const apiUrl = (path) => `${API_BASE_URL}${path}`;

export const getAdminToken = () => sessionStorage.getItem("adminToken") || "";

export const adminFetch = (path, options = {}) => {
  const headers = new Headers(options.headers || {});
  const token = getAdminToken();

  if (token) headers.set("Authorization", `Bearer ${token}`);

  return fetch(apiUrl(path), {
    ...options,
    headers,
  });
};

// ✅ Fix - uploads served directly, not through /api
export const getAssetUrl = (path) => {
  if (!path) return "/images/no-image.png";
  if (path.startsWith("http")) return path;
  if (path.startsWith("/uploads/")) return `${ASSET_BASE_URL}${path}`;
  if (path.startsWith("/")) return `${API_BASE_URL}${path}`;
  return path;
};